// export const statusOptions = [
//     "Active",
//      "Pre-admission",
//     "In-active-on hold",
//     "In-active-pending archive",
//   ];

export const titleOptions = [
    "Mr",
    "Mrs",
    "Mis",
    "Dr",
    "Lord",
    "Lady",
    "Professor",
    "Dame",
    "Sir",
    "Captain",
    "Earl",
    "Others",
]

export const maritalStatus = [
    "Single",
    "Married/Civil Partner",
    "Divorced/Person whose civil Partnership has been resolved",
    "Separated",
    "Registered Partnership",
    "Not Disclosed",
]

export const preferredContactMethods = [
    "Email",
    "Letter",
    "Phone",
    "Landline",
    "Text Message",
]

export const locations = [
    "Croydon - Croydon 1",
    "Croydon - Croydon 2",
    "Croydon - Croydon 3",
    "Croydon - Croydon 4",
    "Croydon - Croydon 5",
]

export const fundingRoutes = [
    "Continuing Health Care(CHC)",
    "Social Services",
    "Private",
    "Life Package",
    "DOM Package",
    "Other",
]

export const categoriesOfCare = [
    "Continuing Health Care(CHC)",
    "Social Services",
    "Private",
    "Life Package",
    "DOM Package",
    "Other",
]

export const ethnicityOptions = [
    "White British",
    "White Irish",
    "White Other",
    "Black Caribbean",
    "Black African",
    "Black Other",
    "Indian",
    "Pakistani",
    "Bangladeshi",
    "Chinese",
    "Asian Other",
    "White and Black Caribbean",
    "White and Black African",
    "White and Asian",
    "Mixed Other",
    "Arab",
    "Other"
];

export const genderOptions = [
    "Male",
    "Female",
    "Non-binary",
    "Transgender",
    "Genderqueer",
    "Genderfluid",
    "Agender",
    "Others"
];

export const statusOptions = [
    "Active",
    "Inactive",
    "Pending",
]

export const religionOptions = [
    "Hindu",
    "Muslim",
    "Christian",
    "Buddhist",
    "Others",
]

export const emailTypeOptions = [
    "Home",
    "Work",
    "Other",
]


